import { enModeDemo } from '@/shared/supabase/client';
import { avantChaqueRafale } from '@/shared/supabase/enDirect';
import { depotsDemo } from './demo/depots';
import { partager, type EnVol } from './lectures';
import { depotsSupabase } from './supabase';
import type { Depots } from './types';

/* Une seule table des lectures en vol pour tous les dépôts : une écriture sur
   l'un (un ticket ouvert) peut changer ce que lit l'autre (le chantier). */
const enVol: EnVol = new Map();

/**
 * La cloche, la page et la recherche lisent souvent la même liste au même
 * moment : une seule requête part. Les adresses de fichiers et l'historique ne
 * changent rien : ils n'oublient pas les lectures en vol.
 */
function enCommun(d: Depots): Depots {
  return {
    entreprises: partager(d.entreprises, {
      nom: 'entreprises',
      enVol,
      lectures: ['lister', 'lire'],
      neutres: ['adresseDocument'],
    }),
    partenaires: partager(d.partenaires, {
      nom: 'partenaires',
      enVol,
      lectures: ['lister', 'lire'],
      neutres: ['adresseDocument'],
    }),
    comptes: partager(d.comptes, { nom: 'comptes', enVol, lectures: ['lister'] }),
    chantiers: partager(d.chantiers, {
      nom: 'chantiers',
      enVol,
      lectures: ['lister', 'lire', 'fiches'],
      neutres: ['adressePreuve', 'historique'],
    }),
    modele: partager(d.modele, {
      nom: 'modele',
      enVol,
      lectures: ['lire'],
      neutres: ['documents'],
    }),
    sav: partager(d.sav, {
      nom: 'sav',
      enVol,
      lectures: ['lister', 'lire', 'fiches'],
      neutres: ['adressePreuve', 'historique'],
    }),
    relances: partager(d.relances, { nom: 'relances', enVol, lectures: ['lister'] }),
    releves: partager(d.releves, { nom: 'releves', enVol, lectures: ['lire'] }),
  };
}

let demo: Depots | null = null;
let distants: Depots | null = null;

/** Les données de l'application : l'accès libre (navigateur) ou Supabase. */
export function depots(): Depots {
  if (enModeDemo()) return (demo ??= enCommun(depotsDemo));
  return (distants ??= enCommun(depotsSupabase));
}

/**
 * Oublier les lectures en vol : à appeler quand les données changent ailleurs
 * (le direct de Supabase), pour qu'une relecture ne rejoigne pas une requête
 * partie avant le changement.
 */
export function oublierLecturesEnVol(): void {
  enVol.clear();
}

avantChaqueRafale(oublierLecturesEnVol);

export type * from './types';
